module.exports = __webpack_public_path__ + "img/divine_unboundtoken.588e157.png";